package com.patronat.top.client.domain.reviews

import com.patronat.top.client.data.reviews.ClientReviewsRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.CreateReviewRequest
import com.patronat.top.dto.ReviewMediaRef
import com.patronat.top.dto.ReviewRatingDetails
import com.patronat.top.dto.ReviewResponse

data class CreateClientReviewCommand(
    val venueId: String,
    val rating: Int,
    val details: ReviewRatingDetails? = null,
    val text: String? = null,
    val photos: List<ReviewMediaRef> = emptyList()
)

class CreateClientReviewUseCase(
    private val repository: ClientReviewsRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<CreateClientReviewCommand, DomainResult<ReviewResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: CreateClientReviewCommand): DomainResult<ReviewResponse> {
        return repository.createReview(
            venueId = command.venueId,
            request = CreateReviewRequest(
                rating = command.rating,
                details = command.details,
                text = command.text?.trim()?.takeIf(String::isNotBlank),
                photos = command.photos
            )
        )
    }
}
